// -------------- State -------------- //
import {isEmpty, isEqual} from "lodash/lang"
import {remove} from "lodash/array"

const defaultState = () => ({
  nonUploadedFiles: {},
})
const state = defaultState()


// -------------- Mutations -------------- //
const MUTATION_TYPES = {
  SET_NON_UPLOADED_FILES: "SET_NON_UPLOADED_FILES",
  REMOVE_NON_UPLOADED_FILE: "REMOVE_NON_UPLOADED_FILE",
  CLEAN_UPLOADER: "CLEAN_UPLOADER",
}

const mutations = {
  [MUTATION_TYPES.SET_NON_UPLOADED_FILES](state, {idProcessing: idProcessing, fileList}) {
    if (!state.nonUploadedFiles[idProcessing]) {
      state.nonUploadedFiles[idProcessing] = {}
    }
    state.nonUploadedFiles[idProcessing].fileList = fileList
  },
  [MUTATION_TYPES.REMOVE_NON_UPLOADED_FILE](state, {idProcessing, fileName}) {
    if (!state.nonUploadedFiles[idProcessing]) return
    const fileList = state.nonUploadedFiles[idProcessing].fileList
    if (isEmpty(fileList)) return
    remove(fileList, x => isEqual(x, fileName))
  },
  [MUTATION_TYPES.CLEAN_UPLOADER](state) {
    Object.assign(state, defaultState())
  },
}


// -------------- Getters -------------- //
export const GET_NON_UPLOADED_FILES = "GET_NON_UPLOADED_FILES"

const getters = {
  [GET_NON_UPLOADED_FILES](state) {
    return idProcessing => state.nonUploadedFiles[idProcessing] ? state.nonUploadedFiles[idProcessing].fileList : []
  },
}


// -------------- Actions -------------- //
export const SET_NON_UPLOADED_FILES = "SET_NON_UPLOADED_FILES"
export const REMOVE_NON_UPLOADED_FILE = "REMOVE_NON_UPLOADED_FILE"
export const CLEAN_UPLOADER = "CLEAN_UPLOADER"

const actions = {
  [SET_NON_UPLOADED_FILES]({commit}, {idProcessing, fileList}) {
    commit(MUTATION_TYPES.SET_NON_UPLOADED_FILES, {idProcessing, fileList})
  },
  [REMOVE_NON_UPLOADED_FILE]({commit}, {idProcessing, fileName}) {
    commit(MUTATION_TYPES.REMOVE_NON_UPLOADED_FILE, {idProcessing, fileName})
  },
  [CLEAN_UPLOADER]({commit}) {
    commit(MUTATION_TYPES.CLEAN_UPLOADER)
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}
